import parseContentStore from "../data/content-store.js";
import { isExternalUrl } from "../navigation/navigation-utils.js";

export default function initAlerts() {
  console.log("INIT ALERTS RUNNING");

  const items = parseContentStore();
  console.log("ALL ITEMS:", items);

  const alertItems = items.filter((item) => item.category.includes("alert"));

  console.log("ALERT ITEMS:", alertItems);

  const button = document.querySelector(".sz-utility-bell");
  if (!button) {
    console.warn("Bell not found");
    return;
  }

  const countEl = button.querySelector(".sz-utility-bell__count");
  const tooltip = button.querySelector(".sz-utility-bell__tooltip");
  const icon = button.querySelector(".sz-utility-bell__icon");

  const count = alertItems.length;

  const modalBody = document.getElementById("sz-alerts-modal-body");

  console.log("ALERT COUNT:", count);

  // ✅ STATE UPDATE
  if (count > 0) {
    button.dataset.alertState = "active";

    if (countEl) {
      countEl.textContent = count;
      countEl.hidden = false;
    }

    if (tooltip) {
      tooltip.textContent = count === 1 ? "1 alert" : `${count} alerts`;
    }

    if (icon) {
      icon.classList.remove("bi-bell-slash");
      icon.classList.add("bi-bell-fill");
    }

    // ✅ animation
    if (!window.__alertTimersInitialised) {
      window.__alertTimersInitialised = true;

      const triggerBell = () => {
        button.classList.add("is-animating");

        setTimeout(() => {
          button.classList.remove("is-animating");
        }, 1200);
      };

      // initial delay
      setTimeout(() => {
        triggerBell();

        // repeat
        setInterval(triggerBell, 30000);
      }, 10000);
    }
  } else {
    button.dataset.alertState = "empty";

    if (countEl) countEl.hidden = true;

    if (tooltip) {
      tooltip.textContent = "No alerts at present";
    }

    if (icon) {
      icon.classList.remove("bi-bell-fill");
      icon.classList.add("bi-bell-slash");
    }
  }

  // Accessibility
  button.setAttribute(
    "aria-label",
    count > 0 ? `${count} student alerts` : "No student alerts",
  );

  if (modalBody) {
    modalBody.innerHTML = `
      <div class="sz-card-list">
        ${alertItems.map(renderAlertCard).join("")}
      </div>
    `;
  }

  button.dataset.alertReady = "true";
}

function externalLinkIndicator() {
  return `
    <span class="sz-link-external-icon" aria-hidden="true">
      <i class="bi bi-box-arrow-up-right"></i>
    </span>
    <span class="visually-hidden"> external link</span>
  `;
}

function renderAlertCard(item) {
  const url = item.url || "#";
  const isExternal = isExternalUrl(url);

  return `
    <article class="sz-card sz-card--horizontal" role="listitem">
      <a href="${url}" class="sz-card__link${isExternal ? " is-external" : ""}">

        ${
          item.image
            ? `
          <div class="sz-card__media">
            <img src="${item.image}" alt="${item.title || ""}">
          </div>
        `
            : ""
        }

        <div class="sz-card__body">
          <h3 class="sz-card__title">
            ${item.title}
            ${isExternal ? externalLinkIndicator() : ""}
          </h3>

          ${
            item.message
              ? `<div class="sz-card__summary">${item.message}</div>`
              : ""
          }
        </div>

      </a>
    </article>
  `;
}